// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.spawn-tab__split {
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: 14px;
  flex: 1;
  min-height: 0;
}
.spawn-tab__list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  padding-right: 4px;
}
.spawn-tab__list::-webkit-scrollbar {
  width: 6px;
}
.spawn-tab__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.spawn-tab__new {
  width: 100%;
}
.spawn-tab__zone {
  padding: 9px 11px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 3px solid transparent;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
}
.spawn-tab__zone:hover {
  border-color: rgba(255, 255, 255, 0.2);
}
.spawn-tab__zone:focus-visible {
  outline: 2px solid var(--gold-main);
  outline-offset: 2px;
}
.spawn-tab__zone--selected {
  border-left-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.08);
}
.spawn-tab__zone-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.spawn-tab__zone-name {
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.spawn-tab__zone-meta {
  margin-top: 3px;
  color: #8d8a82;
  font-size: 12px;
}
.spawn-tab__zone-warn {
  margin-top: 4px;
  color: #d9786d;
  font-size: 12px;
}
.spawn-tab__editor {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  padding-right: 4px;
}
.spawn-tab__editor::-webkit-scrollbar {
  width: 6px;
}
.spawn-tab__editor::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.spawn-tab__bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.spawn-tab__name {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  flex: 1;
  width: auto;
  font-size: 16px;
  font-weight: 600;
}
.spawn-tab__name:focus {
  outline: none;
  border-color: var(--gold-main);
}
.spawn-tab__name::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.spawn-tab__section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
}
.spawn-tab__title {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.spawn-tab__hint {
  color: #8d8a82;
  font-size: 13px;
  line-height: 1.45;
}
.spawn-tab__warn {
  color: #d9786d;
  font-size: 13px;
}
.spawn-tab__preview {
  color: #ebe8e1;
}
.spawn-tab__row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.spawn-tab__field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.spawn-tab__label {
  color: #aeaba2;
  font-size: 13px;
}
.spawn-tab__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #aeaba2;
  font-size: 14px;
}
.spawn-tab__num {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: 78px;
  padding: 6px 8px;
  text-align: center;
}
.spawn-tab__num:focus {
  outline: none;
  border-color: var(--gold-main);
}
.spawn-tab__num::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.spawn-tab__select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: auto;
  padding: 6px 8px;
}
.spawn-tab__select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.spawn-tab__select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.spawn-tab__add {
  align-self: flex-start;
}
.spawn-tab__check {
  width: 16px;
  height: 16px;
  justify-self: center;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.spawn-tab__picker {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.35);
}
.spawn-tab__results {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  max-height: 260px;
}
.spawn-tab__results::-webkit-scrollbar {
  width: 6px;
}
.spawn-tab__results::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.spawn-tab__result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.spawn-tab__result-text {
  min-width: 0;
  flex: 1;
}
.spawn-tab__result-name {
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.spawn-tab__result-meta {
  color: #8d8a82;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.spawn-tab__entries {
  display: flex;
  flex-direction: column;
}
.spawn-tab__entry {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) 110px 62px 62px 56px auto;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.spawn-tab__entry--head {
  color: #8d8a82;
  font-size: 12px;
  font-weight: 600;
}
.spawn-tab__species {
  font-size: 14px;
  font-weight: 600;
}
.spawn-tab__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  color: #aeaba2;
  font-size: 13px;
}
.spawn-tab__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.spawn-tab__points {
  display: flex;
  flex-direction: column;
  max-height: 160px;
  overflow-y: auto;
}
.spawn-tab__point {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  color: #aeaba2;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}
.spawn-tab__choice {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.spawn-tab__choice-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.spawn-tab__choice-title {
  font-weight: 600;
  font-size: 15px;
}
.spawn-tab__choice-text {
  color: #8d8a82;
  font-size: 13px;
  line-height: 1.45;
}
.spawn-tab__dungeons {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}
.spawn-tab__dungeons::-webkit-scrollbar {
  width: 6px;
}
.spawn-tab__dungeons::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .spawn-tab * {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/adminPanel/SpawnTab.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAHE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AAKJ;AAFE;EDuJA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECvJE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;AAMJ;AD+IE;EAAuB,UAAA;AC5IzB;AD6IE;EAA6B,oCAAA;EAAsC,kBAAA;ACzIrE;AAVE;EACE,WAAA;AAYJ;AATE;EACE,iBAAA;EACA,2CAAA;EACA,kCAAA;EACA,kBDLK;ECML,qCDfS;ECgBT,eAAA;AAWJ;AATI;EAAU,sCDfA;AC2Bd;AAXI;EAAkB,mCAAA;EAAqC,mBAAA;AAe3D;AAbI;EACE,mCAAA;EACA,qCAAA;AAeN;AAXE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAaJ;AAVE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAYJ;AATE;EACE,eAAA;EACA,cDrCK;ECsCL,eAAA;AAWJ;AARE;EACE,eAAA;EACA,cD1CK;EC2CL,eAAA;AAUJ;AAPE;ED+FA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC/FE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AAWJ;ADkFE;EAAuB,UAAA;AC/EzB;ADgFE;EAA6B,oCAAA;EAAsC,kBAAA;AC5ErE;AAfE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAiBJ;AAdE;EDoDA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC1DE,OAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAwBJ;ADiCE;EAAU,aAAA;EAAe,8BAAA;AC7B3B;AD8BE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACvB1G;AAhCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBDzEK;EC0EL,qCDnFS;ACqHb;AA/BE;ED1BA,eAAA;EACA,gBAAA;EACA,cAzDO;ACqHT;AAhCE;EACE,cDrFK;ECsFL,eAAA;EACA,iBAAA;AAkCJ;AA/BE;EACE,cD1FK;EC2FL,eAAA;AAiCJ;AA9BE;EACE,cDlGG;ACkIP;AA7BE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA+BJ;AA5BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA8BJ;AA3BE;EACE,cDjHK;ECkHL,eAAA;AA6BJ;AA1BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cDzHK;EC0HL,eAAA;AA4BJ;AAzBE;EDVA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECIE,WAAA;EACA,gBAAA;EACA,kBAAA;AAmCJ;ADvCE;EAAU,aAAA;EAAe,8BAAA;AC2C3B;AD1CE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACiD1G;AA3CE;EDjBA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECWE,WAAA;EACA,gBAAA;AAqDJ;AD/DE;EAAU,aAAA;EAAe,8BAAA;ACmE3B;ADlEE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACyE1G;AA7DE;EACE,sBAAA;AA+DJ;AA5DE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,eAAA;AA8DJ;AA3DE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBDxJK;ECyJL,+BDjKQ;AC8NZ;AA1DE;EDjBA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECiBE,iBAAA;AA8DJ;AD7EE;EAAuB,UAAA;ACgFzB;AD/EE;EAA6B,oCAAA;EAAsC,kBAAA;ACmFrE;AAlEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,kDAAA;AAoEJ;AAjEE;EACE,YAAA;EACA,OAAA;AAmEJ;AAhEE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkEJ;AA/DE;EACE,cD3LK;EC4LL,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiEJ;AA9DE;EACE,aAAA;EACA,sBAAA;AAgEJ;AA7DE;EACE,aAAA;EACA,iEAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kDAAA;AA+DJ;AA7DI;EACE,cDhNG;ECiNH,eAAA;EACA,gBAAA;AA+DN;AA3DE;EACE,eAAA;EACA,gBAAA;AA6DJ;AA1DE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,cDhOK;ECiOL,eAAA;AA4DJ;AAzDE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA2DJ;AAxDE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AA0DJ;AAvDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kDAAA;EACA,cDxPK;ECyPL,eAAA;EACA,kCAAA;AAyDJ;AAtDE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAwDJ;AArDE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBDtQK;AC6TT;AApDE;EACE,gBAAA;EACA,eAAA;AAsDJ;AAnDE;EACE,cDlRK;ECmRL,eAAA;EACA,iBAAA;AAqDJ;AAlDE;EDzIA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECyIE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AAsDJ;ADlME;EAAuB,UAAA;ACqMzB;ADpME;EAA6B,oCAAA;EAAsC,kBAAA;ACwMrE;;AAzDA;EACE;IAAe,2BAAA;EA6Df;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Spawns tab of the admin panel: a list of zones on the left, the editor of the chosen one on the right, each\n// concern in its own section so nothing has to be hunted for. Shares the panel's buttons, chips and fields.\n\n.spawn-tab {\n  &__split {\n    display: grid;\n    grid-template-columns: 250px minmax(0, 1fr);\n    gap: 14px;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__list {\n    @include ink.scroll;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-height: 0;\n    padding-right: 4px;\n  }\n\n  &__new {\n    width: 100%;\n  }\n\n  &__zone {\n    padding: 9px 11px;\n    border: 1px solid ink.$line;\n    border-left: 3px solid transparent;\n    border-radius: ink.$radius;\n    background: ink.$ink-raised;\n    cursor: pointer;\n\n    &:hover { border-color: ink.$line-strong; }\n    &:focus-visible { outline: 2px solid var(--gold-main); outline-offset: 2px; }\n\n    &--selected {\n      border-left-color: var(--gold-main);\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n\n  &__zone-head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__zone-name {\n    font-weight: 600;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__zone-meta {\n    margin-top: 3px;\n    color: ink.$text-3;\n    font-size: 12px;\n  }\n\n  &__zone-warn {\n    margin-top: 4px;\n    color: ink.$danger;\n    font-size: 12px;\n  }\n\n  &__editor {\n    @include ink.scroll;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    min-height: 0;\n    padding-right: 4px;\n  }\n\n  &__bar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__name {\n    @include ink.field;\n    flex: 1;\n    width: auto;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px 14px;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    background: ink.$ink-raised;\n  }\n\n  &__title {\n    @include ink.label;\n  }\n\n  &__hint {\n    color: ink.$text-3;\n    font-size: 13px;\n    line-height: 1.45;\n  }\n\n  &__warn {\n    color: ink.$danger;\n    font-size: 13px;\n  }\n\n  &__preview {\n    color: ink.$text;\n  }\n\n  &__row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  &__label {\n    color: ink.$text-2;\n    font-size: 13px;\n  }\n\n  &__inline {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: ink.$text-2;\n    font-size: 14px;\n  }\n\n  &__num {\n    @include ink.field;\n    width: 78px;\n    padding: 6px 8px;\n    text-align: center;\n  }\n\n  &__select {\n    @include ink.field;\n    width: auto;\n    padding: 6px 8px;\n  }\n\n  &__add {\n    align-self: flex-start;\n  }\n\n  &__check {\n    width: 16px;\n    height: 16px;\n    justify-self: center;\n    accent-color: var(--gold-main);\n    cursor: pointer;\n  }\n\n  &__picker {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 12px;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n    background: ink.$ink-field;\n  }\n\n  &__results {\n    @include ink.scroll;\n    max-height: 260px;\n  }\n\n  &__result {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 6px 4px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__result-text {\n    min-width: 0;\n    flex: 1;\n  }\n\n  &__result-name {\n    font-size: 14px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__result-meta {\n    color: ink.$text-3;\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__entries {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__entry {\n    display: grid;\n    grid-template-columns: minmax(0, 1.6fr) 110px 62px 62px 56px auto;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 0;\n    border-bottom: 1px solid ink.$line;\n\n    &--head {\n      color: ink.$text-3;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  &__species {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  &__stats {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 18px;\n    color: ink.$text-2;\n    font-size: 13px;\n  }\n\n  &__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__points {\n    display: flex;\n    flex-direction: column;\n    max-height: 160px;\n    overflow-y: auto;\n  }\n\n  &__point {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 4px 0;\n    border-bottom: 1px solid ink.$line;\n    color: ink.$text-2;\n    font-size: 13px;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__choice {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n\n  &__choice-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 12px 14px;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n  }\n\n  &__choice-title {\n    font-weight: 600;\n    font-size: 15px;\n  }\n\n  &__choice-text {\n    color: ink.$text-3;\n    font-size: 13px;\n    line-height: 1.45;\n  }\n\n  &__dungeons {\n    @include ink.scroll;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    flex: 1;\n    min-height: 0;\n    padding-right: 4px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spawn-tab * { transition: none !important; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
